import * as f from "react";
import { forwardRef as Pt, useRef as _t, useImperativeHandle as xt } from "react";
import { q as V, z as St, _ as Tt, o as jt, u as G, g as At, m as et, b as Nt, a as ot, n as Rt, s as It } from "./index-CjjiqU7h.mjs";
import { T as Et } from "./index-z2Yki-8P.mjs";
import { u as Vt } from "./useCSSVarCls--o7XUl-F.mjs";
import { C as kt } from "./ContextIsolator-DZCr818D.mjs";
import { u as Lt, z as zt } from "./Portal-CYsTveh8.mjs";
import { g as Dt } from "./motion-P3tHGbiP.mjs";
import { i as Bt, c as Mt } from "./reactNode-CwSzDQK_.mjs";
import { i as Xt } from "./zoom-DWyN4gat.mjs";
import { g as Ht, i as Wt } from "./colors-CS1uQ7ve.mjs";
function rt(o) {
  var e = o.children, a = o.prefixCls, t = o.id, r = o.overlayInnerStyle, n = o.className, i = o.style;
  return /* @__PURE__ */ f.createElement("div", {
    className: V("".concat(a, "-content"), n),
    style: i
  }, /* @__PURE__ */ f.createElement("div", {
    className: "".concat(a, "-inner"),
    id: t,
    role: "tooltip",
    style: r
  }, typeof e == "function" ? e() : e));
}
var N = {
  shiftX: 64,
  adjustY: 1
}, R = {
  adjustX: 1,
  shiftY: !0
}, v = [0, 0], Yt = {
  left: {
    points: ["cr", "cl"],
    overflow: R,
    offset: [-4, 0],
    targetOffset: v
  },
  right: {
    points: ["cl", "cr"],
    overflow: R,
    offset: [4, 0],
    targetOffset: v
  },
  top: {
    points: ["bc", "tc"],
    overflow: N,
    offset: [0, -4],
    targetOffset: v
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: N,
    offset: [0, 4],
    targetOffset: v
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: N,
    offset: [0, -4],
    targetOffset: v
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: R,
    offset: [-4, 0],
    targetOffset: v
  },
  topRight: {
    points: ["br", "tr"],
    overflow: N,
    offset: [0, -4],
    targetOffset: v
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: R,
    offset: [4, 0],
    targetOffset: v
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: N,
    offset: [0, 4],
    targetOffset: v
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: R,
    offset: [4, 0],
    targetOffset: v
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: N,
    offset: [0, 4],
    targetOffset: v
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: R,
    offset: [-4, 0],
    targetOffset: v
  }
}, qt = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"], Ft = function(e, a) {
  var t = e.overlayClassName, r = e.trigger, n = r === void 0 ? ["hover"] : r, i = e.mouseEnterDelay, s = i === void 0 ? 0 : i, l = e.mouseLeaveDelay, p = l === void 0 ? 0.1 : l, d = e.overlayStyle, c = e.prefixCls, m = c === void 0 ? "rc-tooltip" : c, b = e.children, g = e.onVisibleChange, h = e.afterVisibleChange, O = e.transitionName, P = e.animation, w = e.motion, _ = e.placement, x = _ === void 0 ? "right" : _, $ = e.align, B = $ === void 0 ? {} : $, I = e.destroyTooltipOnHide, M = I === void 0 ? !1 : I, S = e.defaultVisible, E = e.getTooltipContainer, k = e.overlayInnerStyle;
  e.arrowContent;
  var X = e.overlay, H = e.id, T = e.showArrow, W = T === void 0 ? !0 : T, Y = St(e, qt), j = _t(null);
  xt(a, function() {
    return j.current;
  });
  var L = Tt({}, Y);
  "visible" in e && (L.popupVisible = e.visible);
  var q = function() {
    return /* @__PURE__ */ f.createElement(rt, {
      key: "content",
      prefixCls: m,
      id: H,
      overlayInnerStyle: k
    }, X);
  };
  return /* @__PURE__ */ f.createElement(Et, jt({
    popupClassName: t,
    prefixCls: m,
    popup: q,
    action: n,
    builtinPlacements: Yt,
    popupPlacement: x,
    ref: j,
    popupAlign: B,
    getPopupContainer: E,
    onPopupVisibleChange: g,
    afterPopupVisibleChange: h,
    popupTransitionName: O,
    popupAnimation: P,
    popupMotion: w,
    defaultPopupVisible: S,
    autoDestroy: M,
    mouseLeaveDelay: p,
    popupStyle: d,
    mouseEnterDelay: s,
    arrow: W
  }, L), b);
};
const Zt = /* @__PURE__ */ Pt(Ft);
function Ut(o) {
  const {
    sizePopupArrow: e,
    borderRadiusXS: a,
    borderRadiusOuter: t
  } = o, r = e / 2, n = 0, i = r, s = t * 1 / Math.sqrt(2), l = r - t * (1 - 1 / Math.sqrt(2)), p = r - a * (1 / Math.sqrt(2)), d = t * (Math.sqrt(2) - 1) + a * (1 / Math.sqrt(2)), c = 2 * r - p, m = d, b = 2 * r - s, g = l, h = 2 * r - n, O = i, P = r * Math.sqrt(2) + t * (Math.sqrt(2) - 2), w = t * (Math.sqrt(2) - 1), _ = `polygon(${w}px 100%, 50% ${w}px, ${2 * r - w}px 100%, ${w}px 100%)`, x = `path('M ${n} ${i} A ${t} ${t} 0 0 0 ${s} ${l} L ${p} ${d} A ${a} ${a} 0 0 1 ${c} ${m} L ${b} ${g} A ${t} ${t} 0 0 0 ${h} ${O} Z')`;
  return {
    arrowShadowWidth: P,
    arrowPath: x,
    arrowPolygon: _
  };
}
const Gt = (o, e, a) => {
  const {
    sizePopupArrow: t,
    arrowPolygon: r,
    arrowPath: n,
    arrowShadowWidth: i,
    borderRadiusXS: s,
    calc: l
  } = o;
  return {
    pointerEvents: "none",
    width: t,
    height: t,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: t,
      height: l(t).div(2).equal(),
      background: e,
      clipPath: {
        _multi_value_: !0,
        value: [r, n]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: i,
      height: i,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${G(s)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: a,
      zIndex: 0,
      background: "transparent"
    }
  };
}, at = 8;
function nt(o) {
  const {
    contentRadius: e,
    limitVerticalRadius: a
  } = o, t = e > 12 ? e + 2 : 12;
  return {
    arrowOffsetHorizontal: t,
    arrowOffsetVertical: a ? at : t
  };
}
function D(o, e) {
  return o ? e : {};
}
function Jt(o, e, a) {
  const {
    componentCls: t,
    boxShadowPopoverArrow: r,
    arrowOffsetVertical: n,
    arrowOffsetHorizontal: i
  } = o, {
    arrowDistance: s = 0,
    arrowPlacement: l = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = a || {};
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${t}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, Gt(o, e, r)), {
        "&:before": {
          background: e
        }
      })]
    }, D(!!l.top, {
      [[`&-placement-top > ${t}-arrow`, `&-placement-topLeft > ${t}-arrow`, `&-placement-topRight > ${t}-arrow`].join(",")]: {
        bottom: s,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${t}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      [`&-placement-topLeft > ${t}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: i
        }
      },
      [`&-placement-topRight > ${t}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: i
        }
      }
    })), D(!!l.bottom, {
      [[`&-placement-bottom > ${t}-arrow`, `&-placement-bottomLeft > ${t}-arrow`, `&-placement-bottomRight > ${t}-arrow`].join(",")]: {
        top: s,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${t}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      [`&-placement-bottomLeft > ${t}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: i
        }
      },
      [`&-placement-bottomRight > ${t}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: i
        }
      }
    })), D(!!l.left, {
      [[`&-placement-left > ${t}-arrow`, `&-placement-leftTop > ${t}-arrow`, `&-placement-leftBottom > ${t}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${t}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${t}-arrow`]: {
        top: n
      },
      [`&-placement-leftBottom > ${t}-arrow`]: {
        bottom: n
      }
    })), D(!!l.right, {
      [[`&-placement-right > ${t}-arrow`, `&-placement-rightTop > ${t}-arrow`, `&-placement-rightBottom > ${t}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${t}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${t}-arrow`]: {
        top: n
      },
      [`&-placement-rightBottom > ${t}-arrow`]: {
        bottom: n
      }
    }))
  };
}
function Kt(o, e, a, t) {
  if (t === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const r = t && typeof t == "object" ? t : {}, n = {};
  switch (o) {
    case "top":
    case "bottom":
      n.shiftX = e.arrowOffsetHorizontal * 2 + a, n.shiftY = !0, n.adjustY = !0;
      break;
    case "left":
    case "right":
      n.shiftY = e.arrowOffsetVertical * 2 + a, n.shiftX = !0, n.adjustX = !0;
      break;
  }
  const i = Object.assign(Object.assign({}, n), r);
  return i.shiftX || (i.adjustX = !0), i.shiftY || (i.adjustY = !0), i;
}
const tt = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, Qt = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, te = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function ee(o) {
  const {
    arrowWidth: e,
    autoAdjustOverflow: a,
    arrowPointAtCenter: t,
    offset: r,
    borderRadius: n,
    visibleFirst: i
  } = o, s = e / 2, l = {};
  return Object.keys(tt).forEach((p) => {
    const d = t && Qt[p] || tt[p], c = Object.assign(Object.assign({}, d), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (l[p] = c, te.has(p) && (c.autoArrow = !1), p) {
      case "top":
      case "topLeft":
      case "topRight":
        c.offset[1] = -s - r;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        c.offset[1] = s + r;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        c.offset[0] = -s - r;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        c.offset[0] = s + r;
        break;
    }
    const m = nt({
      contentRadius: n,
      limitVerticalRadius: !0
    });
    if (t)
      switch (p) {
        case "topLeft":
        case "bottomLeft":
          c.offset[0] = -m.arrowOffsetHorizontal - s;
          break;
        case "topRight":
        case "bottomRight":
          c.offset[0] = m.arrowOffsetHorizontal + s;
          break;
        case "leftTop":
        case "rightTop":
          c.offset[1] = -m.arrowOffsetHorizontal - s;
          break;
        case "leftBottom":
        case "rightBottom":
          c.offset[1] = m.arrowOffsetHorizontal + s;
          break;
      }
    c.overflow = Kt(p, m, e, a), i && (c.htmlRegion = "visibleFirst");
  }), l;
}
const oe = (o) => {
  const {
    componentCls: e,
    // ant-tooltip
    tooltipMaxWidth: a,
    tooltipColor: t,
    tooltipBg: r,
    tooltipBorderRadius: n,
    zIndexPopup: i,
    controlHeight: s,
    boxShadowSecondary: l,
    paddingSM: p,
    paddingXS: d
  } = o;
  return [
    {
      [e]: Object.assign(Object.assign(Object.assign(Object.assign({}, Nt(o)), {
        position: "absolute",
        zIndex: i,
        display: "block",
        width: "max-content",
        maxWidth: a,
        visibility: "visible",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": r,
        // Wrapper for the tooltip content
        [`${e}-inner`]: {
          minWidth: "1em",
          minHeight: s,
          padding: `${G(o.calc(p).div(2).equal())} ${G(d)}`,
          color: t,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: r,
          borderRadius: n,
          boxShadow: l,
          boxSizing: "border-box"
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${e}-inner`]: {
            borderRadius: o.min(n, at)
          }
        },
        [`${e}-content`]: {
          position: "relative"
        }
      }), Ht(o, (c, m) => {
        let {
          darkColor: b
        } = m;
        return {
          [`&${e}-${c}`]: {
            [`${e}-inner`]: {
              backgroundColor: b
            },
            [`${e}-arrow`]: {
              "--antd-arrow-background-color": b
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    Jt(o, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${e}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: o.sizePopupArrow
      }
    }
  ];
}, re = (o) => Object.assign(Object.assign({
  zIndexPopup: o.zIndexPopupBase + 70
}, nt({
  contentRadius: o.borderRadius,
  limitVerticalRadius: !0
})), Ut(et(o, {
  borderRadiusOuter: Math.min(o.borderRadiusOuter, 4)
}))), it = function(o) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return At("Tooltip", (t) => {
    const {
      borderRadius: r,
      colorTextLightSolid: n,
      colorBgSpotlight: i
    } = t, s = et(t, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: n,
      tooltipBorderRadius: r,
      tooltipBg: i
    });
    return [oe(s), Xt(t, "zoom-big-fast")];
  }, re, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: e
  })(o);
};
function st(o, e) {
  const a = Wt(e), t = V({
    [`${o}-${e}`]: e && a
  }), r = {}, n = {};
  return e && !a && (r.background = e, n["--antd-arrow-background-color"] = e), {
    className: t,
    overlayStyle: r,
    arrowStyle: n
  };
}
const ae = (o) => {
  const {
    prefixCls: e,
    className: a,
    placement: t = "top",
    title: r,
    color: n,
    overlayInnerStyle: i
  } = o, {
    getPrefixCls: s
  } = f.useContext(ot), l = s("tooltip", e), [p, d, c] = it(l), m = st(l, n), b = m.arrowStyle, g = Object.assign(Object.assign({}, i), m.overlayStyle), h = V(d, c, l, `${l}-pure`, `${l}-placement-${t}`, a, m.className);
  return p(/* @__PURE__ */ f.createElement("div", {
    className: h,
    style: b
  }, /* @__PURE__ */ f.createElement("div", {
    className: `${l}-arrow`
  }), /* @__PURE__ */ f.createElement(rt, Object.assign({}, o, {
    className: d,
    prefixCls: l,
    overlayInnerStyle: g
  }), r)));
}, ne = ae;
var ie = function(o, e) {
  var a = {};
  for (var t in o)
    Object.prototype.hasOwnProperty.call(o, t) && e.indexOf(t) < 0 && (a[t] = o[t]);
  if (o != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, t = Object.getOwnPropertySymbols(o); r < t.length; r++)
      e.indexOf(t[r]) < 0 && Object.prototype.propertyIsEnumerable.call(o, t[r]) && (a[t[r]] = o[t[r]]);
  return a;
};
const se = /* @__PURE__ */ f.forwardRef((o, e) => {
  var a, t;
  const {
    prefixCls: r,
    openClassName: n,
    getTooltipContainer: i,
    overlayClassName: s,
    color: l,
    overlayInnerStyle: p,
    children: d,
    afterOpenChange: c,
    afterVisibleChange: m,
    destroyTooltipOnHide: b,
    arrow: g = !0,
    title: h,
    overlay: O,
    builtinPlacements: P,
    arrowPointAtCenter: w = !1,
    autoAdjustOverflow: _ = !0
  } = o, x = !!g, [, $] = Rt(), {
    getPopupContainer: B,
    getPrefixCls: I,
    direction: M
  } = f.useContext(ot), S = It("Tooltip"), E = f.useRef(null), k = () => {
    var u;
    (u = E.current) === null || u === void 0 || u.forceAlign();
  };
  f.useImperativeHandle(e, () => {
    var u;
    return {
      forceAlign: k,
      forcePopupAlign: () => {
        S.deprecated(!1, "forcePopupAlign", "forceAlign"), k();
      },
      nativeElement: (u = E.current) === null || u === void 0 ? void 0 : u.nativeElement
    };
  }), process.env.NODE_ENV !== "production" && ([["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"]].forEach((u) => {
    let [y, C] = u;
    S.deprecated(!(y in o), y, C);
  }), process.env.NODE_ENV !== "production" && S(!b || typeof b == "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly."), process.env.NODE_ENV !== "production" && S(!g || typeof g == "boolean" || !("arrowPointAtCenter" in g), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead."));
  const [X, H] = Vt(!1, {
    value: (a = o.open) !== null && a !== void 0 ? a : o.visible,
    defaultValue: (t = o.defaultOpen) !== null && t !== void 0 ? t : o.defaultVisible
  }), T = !h && !O && h !== 0, W = (u) => {
    var y, C;
    H(T ? !1 : u), T || ((y = o.onOpenChange) === null || y === void 0 || y.call(o, u), (C = o.onVisibleChange) === null || C === void 0 || C.call(o, u));
  }, Y = f.useMemo(() => {
    var u, y;
    let C = w;
    return typeof g == "object" && (C = (y = (u = g.pointAtCenter) !== null && u !== void 0 ? u : g.arrowPointAtCenter) !== null && y !== void 0 ? y : w), P || ee({
      arrowPointAtCenter: C,
      autoAdjustOverflow: _,
      arrowWidth: x ? $.sizePopupArrow : 0,
      borderRadius: $.borderRadius,
      offset: $.marginXXS,
      visibleFirst: !0
    });
  }, [w, g, P, $]), j = f.useMemo(() => h === 0 ? h : O || h || "", [O, h]), L = /* @__PURE__ */ f.createElement(kt, {
    space: !0
  }, typeof j == "function" ? j() : j), {
    getPopupContainer: q,
    placement: K = "top",
    mouseEnterDelay: lt = 0.1,
    mouseLeaveDelay: ct = 0.1,
    overlayStyle: ft,
    rootClassName: pt
  } = o, Q = ie(o, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName"]), A = I("tooltip", r), mt = I(), ut = o["data-popover-inject"];
  let F = X;
  !("open" in o) && !("visible" in o) && T && (F = !1);
  const Z = /* @__PURE__ */ f.isValidElement(d) && !Bt(d) ? d : /* @__PURE__ */ f.createElement("span", null, d), z = Z.props, dt = !z.className || typeof z.className == "string" ? V(z.className, n || `${A}-open`) : z.className, [gt, bt, ht] = it(A, !ut), U = st(A, l), vt = U.arrowStyle, wt = Object.assign(Object.assign({}, p), U.overlayStyle), yt = V(s, {
    [`${A}-rtl`]: M === "rtl"
  }, U.className, pt, bt, ht), [Ct, Ot] = Lt("Tooltip", Q.zIndex), $t = /* @__PURE__ */ f.createElement(Zt, Object.assign({}, Q, {
    zIndex: Ct,
    showArrow: x,
    placement: K,
    mouseEnterDelay: lt,
    mouseLeaveDelay: ct,
    prefixCls: A,
    overlayClassName: yt,
    overlayStyle: Object.assign(Object.assign({}, vt), ft),
    getTooltipContainer: q || i || B,
    ref: E,
    builtinPlacements: Y,
    overlay: L,
    visible: F,
    onVisibleChange: W,
    afterVisibleChange: c ?? m,
    overlayInnerStyle: wt,
    arrowContent: /* @__PURE__ */ f.createElement("span", {
      className: `${A}-arrow-content`
    }),
    motion: {
      motionName: Dt(mt, "zoom-big-fast", o.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!b
  }), F ? Mt(Z, {
    className: dt
  }) : Z);
  return gt(/* @__PURE__ */ f.createElement(zt.Provider, {
    value: Ot
  }, $t));
}), J = se;
process.env.NODE_ENV !== "production" && (J.displayName = "Tooltip");
J._InternalPanelDoNotUseOrYouWillBeFired = ne;
const ve = J;
export {
  rt as P,
  ve as T,
  Ut as a,
  nt as b,
  ee as c,
  Jt as g
};
//# sourceMappingURL=index-BP092b3A.mjs.map
